var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 39C39.5 39.4374 39.291 39.9944 38.6177 40.6499C37.9397 41.31 36.8805 41.9736 35.4497 42.5627C32.5951 43.7382 28.5478 44.5 24 44.5C19.4522 44.5 15.4049 43.7382 12.5503 42.5627C11.1195 41.9736 10.0603 41.31 9.38228 40.6499C8.70898 39.9944 8.5 39.4374 8.5 39C8.5 38.5626 8.70898 38.0056 9.38228 37.3501C10.0603 36.69 11.1195 36.0264 12.5503 35.4373C15.4049 34.2618 19.4522 33.5 24 33.5C28.5478 33.5 32.5951 34.2618 35.4497 35.4373C36.8805 36.0264 37.9397 36.69 38.6177 37.3501C39.291 38.0056 39.5 38.5626 39.5 39Z",
    stroke: "#152C5B",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 13.1734C35.5 16.5551 34.1103 23.0639 31.8025 28.7509C30.6533 31.5828 29.3172 34.1068 27.8883 35.8951C26.419 37.7341 25.095 38.5 24 38.5C22.905 38.5 21.581 37.7341 20.1117 35.8951C18.6828 34.1068 17.3467 31.5828 16.1975 28.7509C13.8897 23.0639 12.5 16.5551 12.5 13.1734C12.5 6.70755 17.6674 1.5 24 1.5C30.3326 1.5 35.5 6.70755 35.5 13.1734Z",
    fill: "white",
    stroke: "#152C5B",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 13,
    r: 4.5,
    fill: "white",
    stroke: "#2B4CDE",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCities);
export default __webpack_public_path__ + "static/media/ic_cities.76b4769d79315e999e660026a75dc96a.svg";
export { ForwardRef as ReactComponent };